import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { RxCaretDown } from "react-icons/rx";

import { useClickOutside } from "../hooks/useClickOutside";

import "../CSS/LanguageSwitcher.css";

export default function LanguageSwitcherFixed() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useClickOutside(wrapperRef, () => setOpen(false));

  const changeLang = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("app_lang", lng); // optional: remember choice
  };

  const currentLang = i18n.language;

  return (
    <div ref={wrapperRef} className="lang-switcher-wrapper">
      {/* Toggle icon */}
      <button
        className="lang-toggle-btn"
        onClick={() => setOpen((prev) => !prev)}
      >
        <div className="d-flex justify-content-center align-items-center gap-2">
          <span style={{ fontSize: "16px" }}>
            {i18n.language.toUpperCase()}
          </span>

          <RxCaretDown className="fs-4" />
        </div>
      </button>

      {/* Dropdown */}
      {open && (
        <div className="lang-options">
          <button
            className={currentLang === "en" ? "active" : ""}
            onClick={() => changeLang("en")}
          >
            English
          </button>

          <button
            className={currentLang === "hi" ? "active" : ""}
            onClick={() => changeLang("hi")}
          >
            हिंदी
          </button>

          <button
            className={currentLang === "zh" ? "active" : ""}
            onClick={() => changeLang("zh")}
          >
            中文
          </button>
        </div>
      )}
    </div>
  );
}

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useClickOutside(wrapperRef, () => setOpen(false));

  const changeLang = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("app_lang", lng); // optional: remember choice
  };

  const currentLang = i18n.language;

  return (
    <div ref={wrapperRef} className="lang-switcher-header">
      {/* Toggle icon */}
      <button
        className="lang-toggle-btn"
        onClick={() => setOpen((prev) => !prev)}
      >
        <div className="d-flex justify-content-center align-items-center gap-2">
          <span style={{ fontSize: "16px" }}>
            {i18n.language.toUpperCase()}
          </span>

          <RxCaretDown className="fs-4" />
        </div>
      </button>

      {/* Dropdown */}
      {open && (
        <div className="lang-options float">
          <button
            className={currentLang === "en" ? "active" : ""}
            onClick={() => changeLang("en")}
          >
            English
          </button>

          <button
            className={currentLang === "hi" ? "active" : ""}
            onClick={() => changeLang("hi")}
          >
            हिंदी
          </button>

          <button
            className={currentLang === "zh" ? "active" : ""}
            onClick={() => changeLang("zh")}
          >
            中文
          </button>
        </div>
      )}
    </div>
  );
}
